import Marquee from "react-fast-marquee";

// Reusable editorial marquee band divider.
// variant: "light" (white bg / navy text) | "acid" (green bg / navy text) | "navy" (navy bg / cyan text)
export const MarqueeBand = ({ items = [], variant = "light", speed = 45, direction = "left" }) => {
  const styles = {
    light: "bg-white text-ink border-y-2 border-ink",
    acid: "bg-acid text-ink border-y-2 border-ink",
    navy: "bg-ink text-cyan border-y-2 border-ink",
  };
  return (
    <div className={`overflow-hidden ${styles[variant]}`} data-testid="marquee-band">
      <Marquee speed={speed} direction={direction} gradient={false} className="py-3.5 md:py-4">
        {items.concat(items).map((item, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-6 font-mono text-sm font-bold uppercase tracking-[0.22em] md:text-base">
            {item}
            <span className={`h-2 w-2 ${variant === "navy" ? "bg-acid" : "bg-ink"}`} />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
